import {AfterViewInit, ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {HealthInsuranceService} from '../../../services/health-insurance.service';

import {
  HealthMethods,
  HealthRequestDetails,
  SubRequestDetails,
  HealthScenarios
} from '../../../model/SamanHealthFamilyModels';
import {Label, PaymentInfo, Response, StaticMethods, UploadInfo} from '../../../model/GeneralModels';
import {Router} from '@angular/router';
import {AppSettingsService} from '../../../services/app-settings.service';
import {tap} from 'rxjs/operators';
import {FormBuilder, FormGroup} from '@angular/forms';
import {GeneralService} from '../../../services/general.service';
import {MatDialog} from '@angular/material/dialog';
import {HeightWeightComponent} from '../../../Elements/height-weight/height-weight.component';
import {YesNoDialogComponent} from '../../../Dialogs/yes-no-dialog/yes-no-dialog.component';

@Component({
  selector: 'app-sub-request-details',
  templateUrl: './sub-request-details.component.html',
  styleUrls: [
    '../../../assets/Content/src/css/lib.vendor.css',
    '../../../assets/Content/src/css/lib.picker.css',
    '../../../assets/Content/src/css/ini.bime.css',
    '../../../assets/vendor/font-awesome-4.7/css/font-awesome.min.css',
    '../../../assets/css/light.theme.css'
  ]
})
export class SubRequestDetailsComponent implements OnInit, AfterViewInit {
  title = '';
  requestDetails: HealthRequestDetails = new HealthRequestDetails();
  selectedSubRequestID = 0;
  paymentMode = false;
  filePersianLabel: string;
  fileEnglishLabel: string;
  pageStatus: string;
  paymentInfo: PaymentInfo = new PaymentInfo();
  formGroup: FormGroup;
  myRequestsButton: boolean;
  translation: any = {};
  fileInfo: UploadInfo;

  constructor(
    private service: HealthInsuranceService,
    private router: Router,
    public settings: AppSettingsService,
    private cdRef: ChangeDetectorRef,
    private fb: FormBuilder,
    private generalService: GeneralService,
    public dialog: MatDialog
  ) {
    this.formGroup = this.fb.group({
      discountCode: ['']
    });
  }

  ngOnInit() {
    this.title = 'request ' + this.requestDetails.getRequestID() + ' details';
  }

  ngAfterViewInit() {
    console.log(history.state.requestID);
    if (StaticMethods.checkState(this.router, ['requestID'], '/HEALTH/requests')) {
      this.getDetails(history.state.requestID);
    }
    this.cdRef.detectChanges();
  }

  redirectToUpload(fileLabel: Label, subRequestID: number) {
    console.log('uploading');
    this.fileInfo = {
      id: subRequestID,
      englishName: fileLabel.getEnglishLabel(),
      persianName: fileLabel.getPersianLabel()
    };
  }

  hideUpload($event) {
    this.fileInfo = null;
    this.getDetails(this.requestDetails.getRequestID());
  }

  takeAction(subRequestID: number) {
    const index = this.requestDetails.getSubRequestsDetails().findIndex(item => {
      return item.getSubRequestID() === subRequestID;
    });
    const subRequestDetail = this.requestDetails.getSubRequestsDetails()[index];
    switch (subRequestDetail.getStep()) {
      case HealthScenarios.fileUploaded:
        this.redirectToUpload(
          subRequestDetail.getFileType(this.settings),
          subRequestDetail.getSubRequestID()
        );
        break;
      case HealthScenarios.formSubmitted:
        this.fillForms(subRequestDetail.getSubRequestID());
        break;
      case HealthScenarios.testUploaded:
        const testInfo = subRequestDetail.getFileType(this.settings);
        if (testInfo.getEnglishLabel() === 'WrongInfo') {
          this.openDialog(subRequestID);
        } else if (testInfo.getEnglishLabel() === 'FormResubmission') {
          this.fillForms(subRequestID);
        } else {
          this.redirectToUpload(
            subRequestDetail.getFileType(this.settings),
            subRequestDetail.getSubRequestID()
          );
        }
        break;
      default:
        console.log(subRequestDetail.getStep());
    }
  }

  openDialog(subRequestID): void {
    const dialogRef = this.dialog.open(HeightWeightComponent, {
      width: '250px',
      data: {subRequestID}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.getDetails(this.requestDetails.getRequestID());
      }
    });
  }

  showPaymentPanel() {
    this.router.navigate([`/invoice/HEALTH/${this.requestDetails.getRequestID()}`]);
  }

  selectOffer() {
    this.router.navigate(['/health/family/health-offer'], {
      state: {
        requestID: this.requestDetails.getRequestID()
      }
    });
  }

  fillForms(subRequestID: number) {
    StaticMethods.fillForms(this.router, 'HEALTH', this.requestDetails.getRequestID(), 'ico-person-outline', subRequestID);
  }

  redirectToPayment(paymentMode: string) {
  }

  getDetails(requestID: number) {
    this.service.getHealthRequestDetails(requestID).pipe(
      tap()
    ).subscribe((response: Response) => {
      if (response.success) {
        this.translation = StaticMethods.appendTranslation(response.translation, this.translation);
        let scenario;
        switch (response.data.clientType) {
          case 'B2B':
            scenario = HealthScenarios.getB2BScenario();
            break;
          default:
            scenario = HealthScenarios.getMultipleScenario();
        }
        const requestDetails = HealthMethods.setHealthRequestDetail(response.data,
          scenario, requestID);
        requestDetails.getSubRequestsDetails().forEach(subRequest => {
          this.setButton(subRequest);
        });
        this.requestDetails = requestDetails;
        if (this.requestDetails.getNewInsurance()) {
          const element = document.getElementById('downloadButtonDiv');
          element.style.display = 'block';
        }
      }
    });
  }

  setButton(subRequest: SubRequestDetails) {
    const paymentButtonDiv: HTMLElement = document.getElementById('paymentButtonDiv');
    const offerButtonDiv: HTMLElement = document.getElementById('offerButtonDiv');
    switch (subRequest.getStep()) {
      case HealthScenarios.fileUploaded:
        this.myRequestsButton = false;
        console.log('اپلود عکس ' + subRequest.getFileType(this.settings).getPersianLabel());
        subRequest.setMainLabel('اپلود عکس ' + subRequest.getFileType(this.settings).getPersianLabel());
        break;
      case HealthScenarios.formSubmitted:
        this.myRequestsButton = false;
        subRequest.setMainLabel('تکمیل پرسشنامه');
        break;
      case HealthScenarios.doctorReplied:
        this.myRequestsButton = true;
        break;
      case HealthScenarios.testUploaded:
        const testInfo = subRequest.getFileType(this.settings);
        if (testInfo.getEnglishLabel() === 'WrongInfo') {
          this.myRequestsButton = false;
          subRequest.setMainLabel(testInfo.getPersianLabel());
        } else if (testInfo.getEnglishLabel() === 'FormResubmission') {
          subRequest.setMainLabel('تکمیل مجدد پرسشنامه');
        } else {
          subRequest.setMainLabel('اپلود عکس ' + testInfo.getPersianLabel());
        }
        break;
      case HealthScenarios.paid:
        this.pageStatus = 'payment';
        paymentButtonDiv.style.display = 'block';
        this.myRequestsButton = false;
        break;
      case HealthScenarios.offerSelected:
        this.pageStatus = 'offerSelection';
        offerButtonDiv.style.display = 'block';
        this.myRequestsButton = false;
        break;
      case HealthScenarios.waitingForRelease:
        this.pageStatus = HealthScenarios.waitingForRelease;
        this.myRequestsButton = true;
        break;
      case HealthScenarios.insuranceReleased:
        this.pageStatus = HealthScenarios.insuranceReleased;
        this.myRequestsButton = false;
        break;
    }
  }

  download() {
    this.service.downloadNewInsurance(this.requestDetails.getRequestID()).subscribe((response: Response) => {
      if (response.success) {
        StaticMethods.goToLink(response.data.directLink);
      }
    });
  }

  hideFinance() {
    this.paymentMode = false;
  }

  secondaryClicked(subRequestInfo: SubRequestDetails) {
    switch (subRequestInfo.getStep()) {
      case HealthScenarios.testUploaded:
        const testInfo = subRequestInfo.getFileType(this.settings);
        if (testInfo.getEnglishLabel() === 'HealthOtherTests') {
          this.openFormResendDialog(subRequestInfo.getSubRequestID());
        }
        break;
    }
  }

  private openFormResendDialog(subRequestID: number) {
    StaticMethods.openDialog(this.dialog,
      // tslint:disable-next-line:max-line-length
      'اگر فکر می کنید که این مریضی را ندارید و اشتباها در پرسشنامه زده بودید می توانید مجدد پرسشنامه ی این زیر مجموعه را پر کنید، برای اینکار روی دکمه ی تایید فشار دهید',
      (result) => {
        if (result) {
          console.log(result);
          console.log(subRequestID);
          this.fillForms(subRequestID);
        }
      });
  }
}
